import {
    BORDER_HIDDEN,
    SelectField,
    STYLE_BASIC,
} from '@eventbrite/eds-input-field';
import { getSelectPropValues } from '@eventbrite/eds-select';
import { gettext } from '@eventbrite/i18n';
import classNames from 'classnames';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import React, { FunctionComponent } from 'react';
import type { Locale } from '../../api/models/locale';
import { useIsScrollableCtaExperimentEnabled } from '../../utils/hooks/statsig';
import './LanguageSelector.scss';

const getLanguages = (locales: Array<Locale>) => {
    const unsupportedLocales = [
        'en_IE',
        'en_NZ',
        'en_HK',
        'en_SG',
        'de_AT',
        'fr_BE',
        'nl_BE',
        'es_PE',
        'es_CL',
        'es_CO',
    ];

    return sortBy(
        // Don't display locales that aren't supported on Event Type/Language
        filter(locales, ({ locale }) => !unsupportedLocales.includes(locale)),
        'localized_language_name',
    );
};

export interface LanguageSelectorProps {
    defaultLocale: string;
    locales: Array<Locale>;
    onChange?: (newValue: string, index: number) => void;
}

export const LanguageSelector: FunctionComponent<LanguageSelectorProps> = ({
    defaultLocale,
    locales,
    onChange,
}) => {
    const wrapperClassName = classNames({
        'language-selector-no-padding': useIsScrollableCtaExperimentEnabled(),
    });
    return (
        <div className={wrapperClassName}>
            <SelectField
                id="language-select-field"
                borderType={BORDER_HIDDEN}
                values={getSelectPropValues(
                    getLanguages(locales),
                    'localized_language_name',
                    'locale',
                )}
                label={gettext('Select your language')}
                defaultValue={defaultLocale}
                onChange={onChange}
                data-automation="language-dropdown"
                name="language-select-field"
                style={STYLE_BASIC}
            />
        </div>
    );
};
